const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)') === true || window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;
if(!isReduced) {
  document.addEventListener("DOMContentLoaded", (event) => {
    const scaleElements = document.querySelectorAll(".js-scale-animation");

    // Function to handle the scroll event for each element
    function handleScaleScroll(scaleElement) {
      const scrollPosition = window.scrollY;
      const viewportHeight = window.innerHeight;
      const elementTop = scaleElement.getBoundingClientRect().top + scrollPosition;

      // Define the start and end points relative to the element's position
      const startPercentage = 0; // Start at the top of the viewport
      const endPercentage = 60; // End at 60% of viewport height

      const startPixel = elementTop - viewportHeight * (1 - startPercentage / 100);
      const endPixel = elementTop - viewportHeight * (1 - endPercentage / 100);

      if (scrollPosition >= startPixel && scrollPosition <= endPixel) {
        const progress = (scrollPosition - startPixel) / (endPixel - startPixel);
        const scaleValue = 0.8 + progress * 0.2; // From scale(0.8) to scale(1)
        const opacityValue = 0.9 + progress * 0.1; // From opacity 0.9 to 1

        // Apply the transformation
        scaleElement.style.transform = `scale(${scaleValue})`;
        scaleElement.style.opacity = opacityValue;
      } else if (scrollPosition > endPixel) {
        // Ensure the element stays at the final state after the scroll range
        scaleElement.style.transform = `scale(1)`;
        scaleElement.style.opacity = 1;
      } else {
        // Before the start, set the initial state
        scaleElement.style.transform = `scale(0.8)`;
        scaleElement.style.opacity = 0.9;
      }
    }

    // Set up the IntersectionObserver for lazy loading the scroll listener
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const scaleElement = entry.target;

          if (entry.isIntersecting) {
            const scrollHandler = () => handleScaleScroll(scaleElement);

            // Add scroll event listener when the element is in view
            window.addEventListener("scroll", scrollHandler);
            // Call the function initially when the element comes into view
            handleScaleScroll(scaleElement);

            // Store the handler reference to remove it later
            scaleElement._scrollHandler = scrollHandler;
          } else {
            // Remove the scroll event listener when the element goes out of view
            window.removeEventListener("scroll", scaleElement._scrollHandler);
          }
        });
      },
      { threshold: 0.1 } // Adjust threshold as needed
    );

    scaleElements.forEach((element) => observer.observe(element));
  });
}
